import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-pagination-table',
  templateUrl: './pagination-table.component.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './pagination-table.component.scss',
})
export class PaginationTableComponent implements OnChanges {
  @Input() totalResults: number = 0;
  @Input() pageSize: number = 50;
  @Input() pageOffset: number = 0;
  @Input() pageIndex: number = 0; // MatPaginator is 0-indexed
  pageSizeOptions: number[] = [5, 10, 20, 50, 100]; // Options for items per page

  @Output() pageChange = new EventEmitter<any>(); // Emits the 1-indexed page number

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  ngOnChanges(changes: SimpleChanges): void {
    // Update paginator properties when inputs change
    if (changes['totalResults']) {
      this.totalResults = changes['totalResults'].currentValue;
    }
    if (changes['pageSize']) {
      this.pageSize = changes['pageSize'].currentValue;
    }
    // If you want to reset pageIndex when totalResults or pageSize changes, you can do so here
    // For example, if totalResults becomes 0, reset pageIndex to 0.
    // Or if the current page is no longer valid after a pageSize change.
  }

  /**
   * Handles the page event emitted by MatPaginator.
   * @param event The PageEvent object containing pageIndex, pageSize, and length.
   */
  onMatPageChange(event: PageEvent): void {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    // Emit the 1-indexed page number to the parent component
    this.pageChange.emit(event);
  }
}
